import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import ProductCard from '../components/ProductCard'
import { productAPI } from '../services/api'
import './Products.css'
import { useDocumentMeta } from '../seo/useDocumentMeta'

function Products() {
  useDocumentMeta()
  const [searchParams] = useSearchParams();
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  
  // 从URL参数获取分类，如果没有则默认为'all'
  const urlCategory = searchParams.get('category');
  const [selectedCategory, setSelectedCategory] = useState(urlCategory || 'all')

  // 监听URL参数变化，更新选中的分类
  useEffect(() => {
    const urlCategory = searchParams.get('category');
    if (urlCategory) {
      setSelectedCategory(urlCategory);
    } else {
      setSelectedCategory('all');
    }
  }, [searchParams]);

  // 获取产品数据
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true)
        const result = await productAPI.getProducts({
          category: selectedCategory !== 'all' ? selectedCategory : undefined
        })
        
        if (result.success && Array.isArray(result.data)) {
          setProducts(result.data)
        } else {
          throw new Error(result.message || 'Failed to fetch products')
        }
      } catch (err) {
        console.error('Failed to fetch products:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchProducts()
  }, [selectedCategory])

  // 处理分类切换
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    // 更新URL参数
    const newSearchParams = new URLSearchParams(searchParams);
    if (category === 'all') {
      newSearchParams.delete('category');
    } else {
      newSearchParams.set('category', category);
    }
    // 更新URL但不刷新页面
    window.history.replaceState({}, '', `${window.location.pathname}?${newSearchParams.toString()}`);
  };

  // 加载状态
  if (loading) {
    return (
      <div className="products-page">
        <div className="loading-container">
          <h2>Loading...</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    )
  }

  // 错误状态
  if (error) {
    return (
      <div className="products-page">
        <div className="error-container">
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      </div>
    )
  }

  return (
    <div className="products-page">
      <div className="products-header">
        <h1>All Products</h1>
        <p>Explore our intimate collection, showcasing distinctive and innovative products in a variety of styles and designs.</p>
      </div>

      <div className="category-filter">
        <button 
          className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
          onClick={() => handleCategoryChange('all')}
        >
          View All
        </button>
        <button 
          className={`category-btn ${selectedCategory === 'Vibrators' ? 'active' : ''}`}
          onClick={() => handleCategoryChange('Vibrators')}
        >
          Vibrators
        </button>
        <button 
          className={`category-btn ${selectedCategory === 'Sexy Lingerie' ? 'active' : ''}`}
          onClick={() => handleCategoryChange('Sexy Lingerie')}
        >
          Lingerie
        </button>
        <button 
          className={`category-btn ${selectedCategory === 'Best' ? 'active' : ''}`}
          onClick={() => handleCategoryChange('Best')}
        >
          Best
        </button>
        <button 
          className={`category-btn ${selectedCategory === 'New' ? 'active' : ''}`}
          onClick={() => handleCategoryChange('New')}
        >
          New
        </button>
      </div>

      <div className="products-grid">
        {products.map(product => (
          <ProductCard key={product._id} product={product} />
        ))}
      </div>

      {products.length === 0 && !loading && (
        <div className="no-products">
          <h3>No Products Found</h3>
          <p>No products available in this category.</p>
        </div>
      )}
    </div>
  )
}

export default Products
